export const styles = {
    'html, body': {
        fontFamily: 'GSKPrecision-Regular, Arial, sans-serif',
        // color: props.colorMode === 'dark' ? 'white' : 'dark.700',
        _light: {
            color: 'dark.700',
        },
        _dark: {
            color: 'white',
        },
    },
    body: {
        // backgroundColor: _dark === 'dark' ? 'black' : 'white',
        _light: {
            color: 'black',
        },
        _dark: {
            color: 'white',
        },
    },
    '.chat-progress-message': {
        // color: props.colorMode === 'dark' ? 'rgba(255, 255, ,255, 0.7)' : 'rgba(84, 79, 64, 0.7)',
        _light: {
            color: 'rgba(84, 79, 64, 0.7)',
        },
        _dark: {
            color: 'rgba(255, 255, ,255, 0.7)',
        },
    },
}
